import React from 'react'

const Manual_giftcard_mensuales = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Gift card mensuales
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende a gestionar y configurar las gift cards mensuales dentro del ecosistema de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Gift_card_mensuales__b58X0nuFQfKl9FQ3sSK6rw?as=scrollable"
          className="scribe-iframe-general-124"
          width="100%"
          height="10400"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_giftcard_mensuales
